<template>
  <span>
    <DaiCapaGeojson
      id="asentamientos_humanos"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_asentamientos-humanos.geojson'"
      titulo="Asentamientos humanos"
      :estilo-capa="{ fill:{color:'#B3B3B3'}, stroke: { width: 1,color:'#B3B3B3' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.asentamientos_humanos"
    />
    <DaiCapaGeojson
      id="temporal_anual"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-temporal-anual.geojson'"
      titulo="Anual"
      :estilo-capa="{ fill:{color:'#FBF976'}, stroke: { width: 1,color:'#FBF976' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.temporal_anual"
    />
    <DaiCapaGeojson
      id="temporal_anual_permanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-temporal-anual-y-permanente.geojson'"
      titulo="Anual y permanente"
      :estilo-capa="{ fill:{color:'#FAC57D'}, stroke: { width: 1,color:'#FAC57D' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.temporal_anual_permanente"
    />
    <DaiCapaGeojson
      id="temporal_permanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-temporal-permanente.geojson'"
      titulo="Permanente"
      :estilo-capa="{ fill:{color:'#F99F24'}, stroke: { width: 1,color:'#F99F24' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.temporal_permanente"
    />

    <DaiCapaGeojson
      id="temporal_semipermanente_permanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-temporal-semipermanente-y-permanente.geojson'"
      titulo="Semipermanente y permanente"
      :estilo-capa="{ fill:{color:'#F72322'}, stroke: { width: 1,color:'#F72322' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.temporal_semipermanente_permanente"
    />

    <DaiCapaGeojson
      id="temporal_semipermanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-temporal-semipermanente.geojson'"
      titulo="Semipermanente"
      :estilo-capa="{ fill:{color:'#880009'}, stroke: { width: 1 ,color:'#880009' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.temporal_semipermanente"
    />

    <DaiCapaGeojson
      id="riego_anual"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-riego-anual.geojson'"
      titulo="Anual"
      :estilo-capa="{ fill:{color:'#8FF70E'}, stroke: { width: 1 ,color:'#8FF70E' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.riego_anual"
    />

    <DaiCapaGeojson
      id="riego_anual_permanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-riego-anual-y-permanente.geojson'"
      titulo="Anual y permanente"
      :estilo-capa="{ fill:{color:'#47d168'}, stroke: { width: 1 ,color:'#47d168' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.riego_anual_permanente"
    />

    <DaiCapaGeojson
      id="riego_anual_semipermanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-riego-anual-y-semipermanente.geojson'"
      titulo="Anual y semipermanente"
      :estilo-capa="{ fill:{color:'#419434'}, stroke: { width: 1 ,color:'#419434' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.riego_anual_semipermanente"
    />
    <DaiCapaGeojson
      id="riego_semipermanente"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-riego-semipermanente.geojson'"
      titulo="Semipermanente"
      :estilo-capa="{ fill:{color:'#255600'}, stroke: { width: 1 ,color:'#255600' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.riego_semipermanente"
    />

    <DaiCapaGeojson
      id="agricultura_humedad_anual"
      :url="publicPath+'data/capasv2/03_uso_de_suelo_descripcion_agricultura-de-humedad-anual.geojson'"
      titulo="Agricultura de humedad anual"
      :estilo-capa="{ fill:{color:'#9059d1'}, stroke: { width: 1 ,color:'#9059d1' } }"
      :contenidoTooltip="tooltip"
      :z-index="6"
      :use-loader="true"
      :renderizarComoImagen="true"
      :visible.sync="visibles.agricultura_humedad_anual"
    />

    
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      visibles: {
        asentamientos_humanos:false,
        temporal_anual:false,
        temporal_anual_permanente: false,
        temporal_permanente:false,
        temporal_semipermanente_permanente:false,
        temporal_semipermanente:false,
        riego_anual:false,
        riego_anual_permanente : false,
        riego_anual_semipermanente: false,
        riego_semipermanente: false,
        agricultura_humedad_anual: false
      },
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState("mapa", ["temasExpandidos"]),
    esteTemaActivo() {
      return this.temasExpandidos.usosuelo;
    },
  },
  watch: {
    esteTemaActivo(nv) {
        this.visibles.asentamientos_humanos =nv ;
        this.visibles.temporal_anual = nv;
        this.visibles.temporal_anual_permanente =  nv;
        this.visibles.temporal_permanente = nv;
        this.visibles.temporal_semipermanente_permanente = nv;
        this.visibles.temporal_semipermanente = nv;
        this.visibles.riego_anual = nv;
        this.visibles.riego_anual_permanente  =  nv;
        this.visibles.riego_anual_semipermanente =  nv;
        this.visibles.riego_semipermanente =  nv;
        this.visibles.agricultura_humedad_anual =  nv;
    },
  },
  methods:{
    tooltip(f){
      return  `${f.descripcion}`
    }
  },
  beforeMount(){
    let nv = this.esteTemaActivo;
    this.visibles.asentamientos_humanos =nv ;
        this.visibles.temporal_anual = nv;
        this.visibles.temporal_anual_permanente =  nv;
        this.visibles.temporal_permanente = nv;
        this.visibles.temporal_semipermanente_permanente = nv;
        this.visibles.temporal_semipermanente = nv;
        this.visibles.riego_anual = nv;
        this.visibles.riego_anual_permanente  =  nv;
        this.visibles.riego_anual_semipermanente =  nv;
        this.visibles.riego_semipermanente =  nv;
        this.visibles.agricultura_humedad_anual =  nv;
  }
};
</script>